import { defineComponent as _defineComponent } from 'vue'
import virtualList from '@/components/materialTable'
import store from '@/store'
import { matchMixPaibanPlan } from '@/util/common'
import { getPlankMatCode } from '@/util/plankCommonFuncs'
import {
  findStoreId,
  parseAwaitStoreRenderUrl,
  plankAddAwaitStoreFeature,
} from '@/views/newPaiban/component/m-paiban-store/utlis'
import { message } from 'ant-design-vue'
import { nanoid } from 'nanoid'
import { computed, reactive, ref, watch } from 'vue'

import { bujianManageTableConfig } from '../config/tableConfig'
import type { PartType } from '../types/part'
import { initPart } from '../utils'

type List = (PartType & { id?: number | string })[]


export default /*#__PURE__*/_defineComponent({
  __name: 'm-await-paiban-store',
  props: {
    materialParts: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  // 料单板件数据
  materialParts: PartType[]
}



const isSelectAll = ref(false)
const isExpand = ref(false)
const state = reactive({
  show: true,
  isSelectAll: false,
  isLoading: false,
  isExport: false,
  tableBaseData: [] as List,
  tableFinalData: [] as List,
  stockKeys: [] as string[],
  trigger: true,
})
const isShowBox = computed(() => state.show || state.tableFinalData.length)

const selectPart = computed(() =>
  state.tableFinalData.filter((part) => part.isSelected)
)

// 数据变化则重新匹配
watch(
  () => props.materialParts,
  () => {
    dealResetFilterPart(props.materialParts)
  },
  {
    immediate: true,
  }
)

getAwaitStoreList()

/** 高亮提示 */
function tip(str: string | number) {
  return `<i style=${'color:#18a8c7'}>${str}</i>`
}
/** 接口处理 */
// 获取列表 获取所有信息
async function getAwaitStoreList() {
  state.isLoading = true
  await store.dispatch('awaitPaibanStore/getServePlankData')
  let data = store.state.awaitPaibanStore?.servePlankStore ?? []
  data = JSON.parse(JSON.stringify(data))
  data.forEach((plank: any) => {
    const {
      size,
      matCode,
      color,
      plKId,
      is_high_gloss_plank,
      plankNum,
      partUniqueId,
    } = plank
    plank.partUniqueId = partUniqueId ?? nanoid()
    plank.plankID = plKId
    plank.size = size
    plank.matCode = is_high_gloss_plank
      ? matCode.includes('高光_')
        ? matCode
        : '高光_' + matCode
      : matCode
    plank.texture = color
    plank.plankNum = plankNum
    plank.thick = size?.split('*').slice(-1) ?? 0
    plank.isSelected = store.state.awaitPaibanStore?.materialSelectIds.includes(
      plank.id
    )
  })
  state.tableBaseData = data as any
  state.isLoading = false
  dealFilterPart(state.tableBaseData)
  // 是否显示补件列表
  state.show = !!state.tableFinalData.length
  handleSingleSelectChange()
}

// 处理选中
function handleSelectAllChange() {
  state.tableBaseData.forEach((it) => {
    it.isSelected = isSelectAll.value
  })
  recordSelectId()
}
// 处理单个选中
function handleSingleSelectChange() {
  isSelectAll.value =
    state.tableFinalData.length &&
    state.tableFinalData.every((it) => it.isSelected)
      ? state.tableFinalData.every((it) => it.isSelected)
      : false
  recordSelectId()
}

/** 记录选中的id */
function recordSelectId() {
  const ids = selectPart.value.map((it) => it.id)
  store.commit('awaitPaibanStore/setMaterialSelectIds', ids)
}
/** 其他处理函数 */
function dealFilterPart(parts: PartType[]) {
  // 获取所有在料单中待排版库的id
  const awaitStoreIds = store.state.awaitPaibanStore?.inMaterialPageIds ?? []
  state.tableFinalData = parts.filter((part) => {
    const stockKey = `${part.texture}:${part.matCode}:${part.thick}`
    const plan = store.state.materialListStore?.selectedMixPaibanPlans?.find(
      (plan) => matchMixPaibanPlan(plan, part)
    )

    return (
      (state.stockKeys.includes(stockKey) || plan) &&
      !awaitStoreIds.includes(part.id as any)
    )
  })
}
// 重新筛选可补件的板件
function dealResetFilterPart(parts: PartType[]) {
  const stockKeys: string[] = []
  parts.forEach((part) => {
    const matCode = getPlankMatCode(part)
    const stockKey1 = `${part.texture}:${matCode}:${part.thick}`
    const stockKey2 = `${part.oriTexture}:${matCode}:${part.thick}`
    if (!stockKeys.includes(stockKey1)) {
      stockKeys.push(stockKey1)
    }
    if (!stockKeys.includes(stockKey2)) {
      stockKeys.push(stockKey2)
    }
  })
  state.stockKeys = stockKeys
  dealFilterPart(state.tableBaseData)
}

/** 获取待排版库的最终板件数据 */
async function getAwaitStorePlank() {
  try {
    const plankData = state.tableFinalData.filter((it) => it.isSelected) as any
    if (!plankData.length) return []
    const promises = plankData.map((it: any) =>
      parseAwaitStoreRenderUrl(it.render_url, it.from)
    )
    const result = await Promise.all(promises)
    const alreadyUseId = new Set()
    result.forEach((plank: PartType) => {
      initPart(plank)
      const target = findStoreId(plankData, plank, alreadyUseId)
      plankAddAwaitStoreFeature(plank, target)
      plank._plankNum = plank.plankNum
      // 海棠角/斜封边拉手补充 width，与开料清单 dealData、补件库保持一致
      plank.handleSlopes &&
        plank.handleSlopes.forEach(
          (it) => ((it._conflict_uniqueId = nanoid()), (it.width = 10))
        )
      return plank
    })
    alreadyUseId.clear()
    return result
  } catch (error) {
    console.error(error)
    message.error('待排版库数据加载失败')
    return []
  }
}

/** 外部控制内部展开 */
function setExpand(val: boolean) {
  isExpand.value = val
}

// 暴露重置函数和已选数据
expose({
  dealResetFilterPart,
  getAwaitStoreList,
  data: selectPart,
  getAwaitStorePlank,
  setExpand,
})

return { __sfc: true,props, isSelectAll, isExpand, state, isShowBox, selectPart, tip, getAwaitStoreList, handleSelectAllChange, handleSingleSelectChange, recordSelectId, dealFilterPart, dealResetFilterPart, getAwaitStorePlank, setExpand, virtualList, bujianManageTableConfig }
}

})